import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

import { createStorage } from './oidc-storage/local-storage';
import { PostSignoutUserManager } from './PostSignoutUserManager';

export interface ClientConfig {
  authority: string;
  clientId: string;
  scope?: string;
  /**
   * should be a combination of 'code', 'token', 'id_token' or 'none'
   * https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#Combinations
   */
  responseType: string;
  basename: string;
  signInRoute: string;
  signInPopupRoute: string;
  signOutRoute: string;
  signOutPopupRoute: string;
  loginRoute?: string;
  allowResignin?: boolean;
  bypassAuthentication?: boolean;
}

const toUserManagerSettings = ({
  authority,
  clientId,
  scope,
  responseType,
  basename,
  signInRoute,
  signOutRoute,
  signInPopupRoute,
  signOutPopupRoute,
}: ClientConfig): UserManagerSettings => {
  const baseUrl = new URL(`${basename}/`, window.location.origin);
  return {
    authority,
    client_id: clientId,
    scope,
    response_type: responseType,
    redirect_uri: new URL(signInRoute, baseUrl).toString(),
    popup_redirect_uri: new URL(signInPopupRoute, baseUrl).toString(),
    post_logout_redirect_uri: new URL(signOutRoute, baseUrl).toString(),
    popup_post_logout_redirect_uri: new URL(signOutPopupRoute, baseUrl).toString(),
    filterProtocolClaims: true,
    userStore: new WebStorageStateStore({
      store: createStorage(),
      prefix: 'auth',
    }),
  };
};

export const createUserManager = (clientConfig: ClientConfig): PostSignoutUserManager => {
  const userManager = new PostSignoutUserManager(toUserManagerSettings(clientConfig));
  return userManager;
};
